import styled from 'styled-components';

export const ExtensionElement = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin: 10px 0;
  padding: 10px;

  border: 1px solid #000000;
  border-radius: 6px;

  background: #fff;
`;

export const ExtensionName = styled.span`
  flex: 0 0 80%;

  font-size: 16px;
  font-weight: bold;
  text-align: left;
`;
export const ExtensionHint = styled.span<{ noSpace?: boolean; italic?: boolean }>`
  font-size: 12px;
  font-weight: normal;
  ${(props) => props.italic && 'font-style: italic;'}
  ${(props) => !props.noSpace && 'margin: 0 5px;'}
`;

export const ExtensionRight = styled.span`
  flex: 0 1 20%;

  display: flex;
  justify-content: flex-end;
`;

export const ExtensionDetails = styled.span`
  margin-top: 10px;
  margin-bottom: 10px;

  width: 100%;
`;
